import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

export default function Clock(props: any) {
	const [time, setTime] = useState(new Date());

	useEffect(() => {
		var timer = setInterval(() => tick(), 1000);

		return function clearTimer() {
			clearInterval(timer);
		};
	});

	function tick() {
		setTime(new Date());
	}

	return (
		<div className="time-container">
			<span className="current-time">{time.toLocaleString([], { minute: '2-digit', hour: '2-digit', second: '2-digit' })}</span>
		</div>
	)
}